import React from 'react';
import styled from 'styled-components';

import { TLD } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { applyElevation, themeGet, Elevation } from '@packages/ui';

const APP_TLD = getPublicRuntimeConfig('APP_TLD');

/** TEMP Black Days changes
 *
 * note that DE and FR have different start end end days. After black days are over change back to:
 * `variant === FlagVariants.sale ? themeGet.colors('primary') : themeGet.colors('secondary')};`
 */
function isDuringBlackDaysFn(tld: TLD) {
  const blackDaysStart = tld === TLD.DE ? new Date('11/20/2020') : new Date('11/27/2020');
  const blackDaysEnd = tld === TLD.DE ? new Date('12/01/2020') : new Date('12/08/2020');
  const now = new Date();

  return now >= blackDaysStart && now < blackDaysEnd;
}

let isDuringBlackDays = isDuringBlackDaysFn(TLD.DE);

function getSaleFlagColor() {
  if (isDuringBlackDays) {
    return themeGet.colors('black');
  }

  return themeGet.colors('primary');
}

export enum FlagVariants {
  sale = 'sale',
  new = 'new',
}

export const FlagStyled = styled.div<{ variant: FlagVariants; elevation: Elevation }>`
  ${applyElevation}
  width: 52px;
  height: 30px;
  border-radius: 0 5px 5px 0;
  line-height: 30px;
  text-align: center;
  letter-spacing: 1px;
  color: ${themeGet.colors('white')};
  font-size: ${themeGet.fontSize(4)};
  font-family: ${themeGet.fonts('brandSecondary')};
  font-weight: ${themeGet.fontWeight('normal')};
  background-color: ${({ variant }) =>
    variant === FlagVariants.sale ? getSaleFlagColor() : themeGet.colors('secondary')};
  position: absolute;
  left: 0;
`;

interface FlagProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
  variant: FlagVariants;
}

export const SimpleFlag: React.FC<FlagProps> = ({ children, className, variant }) => {
  isDuringBlackDays = isDuringBlackDaysFn(APP_TLD);
  return (
    <FlagStyled className={className} variant={variant} elevation={[1]}>
      {children}
    </FlagStyled>
  );
};
